
















import { Vue, Component } from 'vue-property-decorator';
@Component({
    name: 'LaunchApp'
})
export default class LaunchApp extends Vue {
  clickLaunchApp() {
    window.open(`${process.env.VUE_APP_UNIVERSAL_LINK}${this.$route.fullPath}`);
  }
  clickDontHaveAccount() {
    this.$router.push("/");
  }
}
